import $ from "jquery";
import Backbone from "backbone";

window.$ = window.jQuery = $;
window.Backbone = Backbone;

(async () => {
  await import("bootstrap");

  // Import Select2 UMD
  const mod = await import("select2/dist/js/select2.full.js");

  // Some builds expose the init function as the module itself, others under default
  const init = (typeof mod === "function")
    ? mod
    : (typeof mod?.default === "function" ? mod.default : null);

  if (init) {
    // Call the UMD/CJS initializer so it patches $.fn
    init(window, $);
  }

  // Verify
  if (typeof $.fn.select2 !== "function") {
    throw new Error("Select2 failed to initialize on jQuery");
  }

  await import("../../compare/compare.js.coffee");
})();
